(function($) {
    $(document).ready(function() {

        $('.styled-select').each(function() {
	        $(this).select2({
	            minimumResultsForSearch: Infinity,
	            placeholder: $(this).attr('data-placeholder')
	        });
	    });

        $('.res__date-container input').addClass('styledDatePicker');

        $('.styledDatePicker').pickadate({
            firstDay: 1,
            format: 'dd/mm/yyyy',
            formatSubmit: 'yyyy-mm-dd',
            hiddenName: true,
            min: new Date()
        });
    });
})(jQuery);